import React, { useContext, useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import CategoryIcon from "@mui/icons-material/Category";
import VerifiedIcon from "@mui/icons-material/Verified";
import { Box } from "@mui/system";
import { Chip, Button, Paper, Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import DoneIcon from "@mui/icons-material/Done";
import { GridCloseIcon } from "@mui/x-data-grid";
import { ProVerContext, UserContext } from "../../context/userContext";
import { ProVerContextInfo, UserLoginInfo } from "../../types/context";
import { appLogger } from "../../utils";

export default function ProductVersionDropdown(props: any) {
  const {
    productResponse,
    selectedProVerDataFn,
    selectedProVerData,
    contextProVersion,
  } = props;
  const [result, setresult] = useState<any>([]);
  const [resultdata, setresultdata] = React.useState<any>(result);
  const [rerender, setRerender] = useState(false);
  const [selectedDatas, setselectedDatas] = useState<any>([]);
  const [proverdropdownOpen, setproverdropdownOpen] = useState<any>(false);
  const [ShowErrMsg, setShowErrMsg] = useState<any>(false);
  const {
    ProVersion,
    setProVersion,
    filterDate,
    setFilterDate,
    setcontextProVersion,
    contextRedirectProdPage,
  } = useContext(UserContext) as UserLoginInfo;
  const formproductResponse = () => {
    const tempData: any = [];
    productResponse &&
      productResponse.length > 0 &&
      productResponse.forEach((value: any, key: any) => {
        tempData.push({
          value: value.id,
          title: value.name,
          version: value.version,
          proversion: value.name + value.version,
        });
      });
    tempData.sort((a: any, b: any) => a.title.localeCompare(b.title));
    setresult(tempData);
  };
  useEffect(() => {
    formproductResponse();
  }, [productResponse]);

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "ProductVersionDropdown",
        component: "common",
        fileName: "ProductVersionDropdown.tsx",
        selectedDatas: selectedDatas,
      },
    });
  }, [selectedDatas]);

  const handleOk = () => {
    if (selectedDatas.length > 0) {
      selectedDatas.type = "confirm";
      setproverdropdownOpen(false);
      selectedProVerDataFn(selectedDatas, "confirm");
      setShowErrMsg(false);
    } else {
      if (contextProVersion && contextProVersion.length == 0) {
        setShowErrMsg(true);
        setproverdropdownOpen(true);
      } else {
        setproverdropdownOpen(false);
        setShowErrMsg(false);
      }
    }
  };
  const handleClearAll = () => {
    selectedProVerDataFn([]);
    setcontextProVersion([]);
    setselectedDatas([]);
    setShowErrMsg(true);
    setproverdropdownOpen(true);
  };
  const handleChange = (e: any, data: any) => {
    if (data.length == 0) {
      handleClearAll();
    } else {
      setShowErrMsg(false);
      setselectedDatas(data);
      selectedProVerDataFn(data, "Ok");
    }
  };

  const CustomPaper = (props: any) => {
    return <Paper {...props} sx={{ pb: 0 }} className="prod-ver-dd" />;
  };
  return (
    <div>
      <Autocomplete
        className="prodver-dd"
        selectOnFocus={true}
        open={proverdropdownOpen}
        disabled={props.type == "cuvo-view-tickets" ? true : !result.length}
        onOpen={() => {
          setproverdropdownOpen(true);
        }}
        // clearOnBlur={contextProVersion.length ? true : false}
        onClose={() =>
          contextProVersion.length
            ? [setproverdropdownOpen(false), handleOk()]
            : setproverdropdownOpen(true)
        }
        PaperComponent={CustomPaper}
        disableCloseOnSelect
        disableClearable
        disablePortal={false}
        multiple
        id="fixed-tags-demo"
        value={contextProVersion ? contextProVersion : []}
        onChange={handleChange}
        limitTags={0}
        options={result}
        getOptionLabel={(option: any) => option.title}
        isOptionEqualToValue={(option, value) =>
          option?.proversion === value?.proversion
        }
        // defaultValue={[resultdata[0]]}
        style={{ width: "100%" }}
        // ListboxProps={
        //   {
        //     style: {
        //       maxHeight: '150px',
        //     }
        //   }
        // }
        // defaultValue={[resultdata[0]]}
        renderInput={(params) => (
          <TextField
            // sx={{
            //   // width: { sm: 200, md: 300 },
            //   "& .MuiInputBase-root": {
            //     maxHeight: 50
            //   }
            // }}
            className="custom-select err-pro-ver-select"
            {...params}
            label={
              result &&
              result.length > 0 &&
              contextProVersion &&
              contextProVersion.length == 0
                ? "Select atleast one product *"
                : "Products and Versions"
            }
            // placeholder="Search..."
            size="small"
            error={
              result &&
              result.length > 0 &&
              contextProVersion &&
              contextProVersion.length == 0
                ? true
                : false
            }
            // helperText=
            // {contextProVersion && contextProVersion.length == 0 ? "Select atleast one product *" : null}
          />
        )}
        renderTags={(value, getTagProps) => {
          const numTags = value.length;
          const limitTags = 1;
          return (
            <>
              {value.slice(0, limitTags).map((option, index) => (
                <Chip
                  sx={{
                    "& .MuiChip-label": {
                      overflow: "unset",
                      whiteSpace: "normal",
                    },
                  }}
                  deleteIcon={<></>}
                  {...getTagProps({ index })}
                  key={index}
                  label={option.title + " - " + option.version}
                />
              ))}
              {numTags > limitTags && ` +${numTags - limitTags}`}
            </>
          );
        }}
        // renderTags={(tagValue, getTagProps) =>
        //   tagValue.map((option: any, index: any) => (
        //     <Chip
        //       deleteIcon={<></>}
        //       label={
        //         <>
        //           {/* <CategoryIcon className="rct-icon rct-icon-parent-open" />
        //         {option.title}
        //         <VerifiedIcon className="rct-icon rct-icon-parent-open" />
        //         {option.version} */}
        //           {/* <span className="pro-verison-prod-name">Product:</span> &nbsp; */}
        //           <span className="pro-verison-prod-title">
        //             {option && option.title ? option.title : ""}
        //           </span>
        //           &nbsp; -
        //           {/* <VerifiedIcon className="rct-icon rct-icon-parent-open" /> */}
        //           {/* <span className="pro-verison-prod-name">Version: </span> &nbsp; */}
        //           &nbsp;{" "}
        //           <span className="pro-verison-prod-title">
        //             {option && option.version ? option.version : ""}
        //           </span>
        //         </>
        //       }
        //       {...getTagProps({ index })}
        //     />
        //   ))
        // }
        renderOption={(props: object, option: any, key: any) => (
          <>
            <Box
              sx={{ whiteSpace: "normal" }}
              component="li"
              // sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {/* <CategoryIcon className="rct-icon rct-icon-parent-open" /> */}
              {/* <span className="pro-verison-prod-name">Product:</span> &nbsp; */}
              <span className="pro-verison-prod-title">{option.title}</span>
              &nbsp; -
              {/* <VerifiedIcon className="rct-icon rct-icon-parent-open" /> */}
              {/* <span className="pro-verison-prod-name">Version: </span> &nbsp; */}
              &nbsp;{" "}
              <span className="pro-verison-prod-title">{option.version}</span>
            </Box>
            <Box display="flex" justifyContent="end" className="okclear">
              <Button
                id="ok-btn"
                className="okbtn"
                size="small"
                variant="contained"
                color="primary"
                onClick={() => {
                  handleOk();
                }}
              >
                <DoneIcon /> Ok
              </Button>
              &nbsp;
              <Button
                id="clear-btn"
                className="allclearbtn"
                variant="outlined"
                size="small"
                color="primary"
                onClick={() => {
                  handleClearAll();
                }}
              >
                <GridCloseIcon /> Clear All
              </Button>
            </Box>
          </>
        )}
        // noOptionsText={'Your Customized No Options Text'}
        // noOptionsText={(
        //   <Box display="flex" justifyContent="space-between" alignItems="center">
        //     Color not available
        //     <Button
        //       variant="outlined"
        //       color="primary"
        //       onClick={() => {
        //        }}
        //     >
        //       Add New Color
        //     </Button>
        //   </Box>
        // )}
        sx={{ width: "500px" }}
      />
    </div>
  );
}
